export default __webpack_public_path__ + "static/media/238.9cd15885.svg";